import React from 'react'
import {
  IProps as ICrosslinkCards,
  CrosslinkCards,
  ICardProps,
} from 'marketing-site/src/library/components/CrosslinkCards'
import {
  ICardList as IContentfulCrosslinkCards,
  ICrosslinkCard,
  ITestimonialMiniCard,
  ICardWithImage,
  ICardWithModal,
  ISolutionCard,
} from 'marketing-site/@types/generated/contentful'
import EntryMarker from 'marketing-site/src/components/common/EntryMarker'
import * as Utils from 'marketing-site/src/library/utils'
import { transformCard } from 'marketing-site/src/transformers/elements/ContentfulCard'
import { transformTestimonialMiniCard } from '../elements/ContentfulTestimonialMiniCard'
import { transformCardWithImage } from '../elements/ContentfulCardWithImage'
import { transformCardWithModal } from '../elements/ContentfulCardWithModal'
import { transformSolutionCard } from '../elements/ContentfulSolutionCard'
import { transformCTAWithBackground } from 'marketing-site/src/transformers/elements/ContentfulCTALink'
import { getSnakeCaseFromString } from './ContentfulStatistics'

export const ContentfulCrosslinkCards = (
  crosslinkCards: IContentfulCrosslinkCards,
): React.ReactElement => {
  return (
    <EntryMarker entry={crosslinkCards}>
      {() => <CrosslinkCards {...transformCrosslinkCards(crosslinkCards)} />}
    </EntryMarker>
  )
}

function transformSingleCard(
  card: ICrosslinkCard | ITestimonialMiniCard | ICardWithImage | ICardWithModal | ISolutionCard,
): ICardProps {
  const contentType = card.sys.contentType.sys.id
  switch (contentType) {
    case 'crosslinkCard':
      return transformCard(card as ICrosslinkCard)
    case 'testimonialMiniCard':
      return transformTestimonialMiniCard(card as ITestimonialMiniCard)
    case 'cardWithImage':
      return transformCardWithImage(card as ICardWithImage)
    case 'cardWithModal':
      return transformCardWithModal(card as ICardWithModal)
    case 'solutionCard':
      return transformSolutionCard(card as ISolutionCard)
  }
}

export function transformCrosslinkCards({ fields }: IContentfulCrosslinkCards): ICrosslinkCards {
  return {
    ...fields,
    cardColor: Utils.getHexColorFromName(fields.cardColor),
    cards: fields.cards.map((card) => transformSingleCard(card)),
    ctaLink: fields.ctaLink && transformCTAWithBackground(fields.ctaLink),
    ctaLinkPosition: fields.ctaLinkPosition && getSnakeCaseFromString(fields.ctaLinkPosition),
  }
}
